// ShopSkeleton.jsx — mirrors the real shop page layout so the swap doesn't jump
import "./shopSkeleton.css";

export default function ShopSkeleton() {
	return (
		<div className="sf-shop-container sf-skeleton">
			<div className="sf-shop-content">
				<div className="sf-shop-main">
					<div className="sf-skeleton-box sf-skeleton-gallery" />

					<div className="sf-skeleton-head">
						<div className="sf-skeleton-box sf-skeleton-eyebrow" />
						<div className="sf-skeleton-box sf-skeleton-title" />
						<div className="sf-skeleton-pills">
							<div className="sf-skeleton-box sf-skeleton-pill" />
							<div className="sf-skeleton-box sf-skeleton-pill" />
						</div>
						<div className="sf-skeleton-box sf-skeleton-subtitle" />
					</div>

					<div className="sf-skeleton-section-head">
						<div className="sf-skeleton-box sf-skeleton-h2" />
					</div>

					<div className="sf-skeleton-tabs">
						{Array.from({ length: 3 }).map((_, i) => (
							<div className="sf-skeleton-box sf-skeleton-tab" key={i} />
						))}
					</div>

					{Array.from({ length: 2 }).map((_, c) => (
						<div className="sf-skeleton-card" key={c}>
							<div className="sf-skeleton-card-head">
								<div className="sf-skeleton-box sf-skeleton-cat" />
							</div>
							{Array.from({ length: 3 }).map((_, i) => (
								<div className="sf-skeleton-row" key={i}>
									<div className="sf-skeleton-row-copy">
										<div className="sf-skeleton-box sf-skeleton-line-lg" />
										<div className="sf-skeleton-box sf-skeleton-line-sm" />
									</div>
									<div className="sf-skeleton-box sf-skeleton-btn" />
								</div>
							))}
						</div>
					))}
				</div>

				<div className="sf-shop-sidebar">
					<div className="sf-skeleton-card sf-skeleton-aside">
						<div className="sf-skeleton-box sf-skeleton-map" />
						<div className="sf-skeleton-aside-body">
							<div className="sf-skeleton-box sf-skeleton-line-lg" />
							<div className="sf-skeleton-box sf-skeleton-line-sm" />
							<div className="sf-skeleton-box sf-skeleton-cta" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
